import { action, makeObservable } from 'mobx';
import { createContext, useContext } from 'react';
import { bpHistory } from 'global/bpHistory';
import IEnrollmentCensusReviewPageStore from 'store/modules/census/enrollment-based/iEnrollmentCensusReviewPageStore';
import { CensusReviewDomainParams } from 'store/modules/census/iCensusReviewPageStore';

export default class CensusReviewPageStore extends IEnrollmentCensusReviewPageStore {
  protected _domainData;

  public onBackRedirect(): void {
    bpHistory.push(`/add-employees/census-upload/${this._domainData.groupId}/${this._domainData.enrollmentPeriodId}`);
  }

  public onCompleteRedirect(): void {
    bpHistory.push(`/add-employees/${this._domainData.groupId}/${this._domainData.enrollmentPeriodId}`);
  }

  constructor(domainData: CensusReviewDomainParams) {
    super();

    this._domainData = domainData;

    makeObservable<CensusReviewPageStore>(this, {
      onBackRedirect: action.bound,
      onCompleteRedirect: action.bound,
    });
  }
}

const CensusReviewPageStoreContext = createContext(new CensusReviewPageStore({} as CensusReviewDomainParams));

export const useCensusReviewPageStore = (): CensusReviewPageStore => {
  return useContext(CensusReviewPageStoreContext);
};

export { CensusReviewPageStoreContext };
